export enum DialogResult {
    Ok,
    No,
    Cancel
};
